














































































































































































































































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
@Component
export default class HeaderComponent extends Vue {
  private win = window;
  private base = window.location;
  private left: boolean = false;

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch((err) => {
          console.log(err);
        });
      }
    }
  }
}
